import config from '../Config';

export const today = +new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());

export const parseDateDesktop = (input) => {
	if (config.date_today_tomorrow_label) {
		if (input === today) return customData.i18n.agenda_date_today;
		if (input === today + 86400000) return customData.i18n.agenda_date_tomorrow;
	}
	return new Date(input).toLocaleDateString(document.documentElement.lang, { weekday: 'long', month: 'long', day: 'numeric' });
};

export const parseURL = (input) => {
	var textarea = document.createElement('textarea');
	textarea.innerHTML = input;
	return textarea.value;
}

export const parseDateDesktopShort = (input, lang) => {
	if (config.date_today_tomorrow_label) {
		 const today = new Date().setHours(0, 0, 0, 0);
		 const tomorrow = today + 86400000;

		 if (input === today) return customData.i18n.agenda_date_today.toLowerCase();
		 if (input === tomorrow) return customData.i18n.agenda_date_tomorrow.toLowerCase();
	}

	return new Date(input).toLocaleDateString(lang === 'nl' ? 'nl' : 'en', {
		 weekday: 'long',
		 month: 'short',
		 day: 'numeric'
	}).replace(/\.$/, '');
};

export const toSmallDateDisplay = (string) => {
	const stringArr = string.split(' ');
	if (stringArr.length <= 1) {
		//today, tomorrow
		return string;
	}
	const shortWeekday = stringArr[0].split('')[0] + stringArr[0].split('')[1];
	const shortMonth = stringArr[2].split('')[0] + stringArr[2].split('')[1] + stringArr[2].split('')[2];
	return shortWeekday + ' ' + stringArr[1] + ' ' + shortMonth;
};

export const toSmallDateDisplayYear = (string) => {
	const stringArr = string.split(' ');
	if (stringArr.length <= 1) {
		//today, tomorrow
		return '';
	}
	const shortMonth = stringArr[2].split('')[0] + stringArr[2].split('')[1] + stringArr[2].split('')[2];
	return stringArr[1] + ' ' + shortMonth + ' ' + stringArr[3];
};

export const toSmallWeekdayDisplay = (string) => {
	const stringArr = string.split(' ');
	if (stringArr.length <= 1) {
		//today, tomorrow
		return string;
	}
	const shortWeekday = stringArr[0].split('')[0] + stringArr[0].split('')[1];
	return shortWeekday.charAt(0).toUpperCase() + shortWeekday.slice(1);
};

export const toLongDateDisplay = (string, lang) => {
	const stringArr = string.split(' ');

	if (stringArr.length < 3) {
		  return [string];
	}

	const capitalizeFirstLetter = (str) => {
		  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
	};

	const shortWeekday = capitalizeFirstLetter(stringArr[0].slice(0, 2));
	const shortMonth = stringArr[2].slice(0, 3).toLowerCase(); // Maand in 3 letters en zonder hoofdletter

	if (lang === 'nl') {
		  return [shortWeekday, stringArr[1], shortMonth];
	} else {
		  return [shortWeekday, shortMonth, stringArr[1]];
	}
};



export const parseDateDesktopMonth = (input) => {
	return new Date(input).toLocaleDateString(document.documentElement.lang, { month: 'long', year: 'numeric' });
};

export const parseDateDay = (timestamp) => {
	return new Date(timestamp).toLocaleDateString(document.documentElement.lang, { weekday: 'long' }).substring(0, 2);
};

export const parseDateNumber = (timestamp) => {
	return new Date(timestamp).toLocaleDateString(document.documentElement.lang, { day: 'numeric' });
};

export const dbDateToTimestamp = (programstart) => {
	if (typeof programstart !== 'string') {
		programstart = programstart.toString();
	}
	return +new Date(`${programstart.substring(0, 4)}`, `${programstart.substring(4, 6) - 1}`, `${programstart.substring(6, 8)}`);
};

export const dbDateToExactTimestamp = (programstart) => {
	if (typeof programstart !== 'string') {
		programstart = programstart.toString();
	}
	return +new Date(
		`${programstart.substring(0, 4)}`,
		`${programstart.substring(4, 6) - 1}`,
		`${programstart.substring(6, 8)}`,
		`${programstart.substring(8, 10)}`,
		`${programstart.substring(10, 12)}`
	);
};

export const getLatest = (array) => {
	if (array.length < 2) return '';
	return dbDateToTimestamp(
		array.reduce((a, b) => {
			return new Date(a) > new Date(b) ? a : b;
		})
	);
};

export const sortByPopularity = (input) => {
	const preSort = sortByRelease(input);
	return preSort.sort((a, b) => b.times.length - a.times.length);
};

export const sortByTime = (input) => {
	input.sort((a, b) => {
		return a.times[0].timestamp - b.times[0].timestamp;
	});
	return input;
};

export const sortByRelease = (input) => {
	let tempWithReleaseDate = input.filter((movie) => movie.date_range.release);
	let tempWithoutReleaseDate = input.filter((movie) => !movie.date_range.release);

	tempWithReleaseDate.sort((a, b) => {
		return dbDateToTimestamp(a.date_range.release + '0000') - dbDateToTimestamp(b.date_range.release + '0000');
	});

	if (tempWithoutReleaseDate.length > 0) {
		tempWithoutReleaseDate.sort((a, b) => a.title.localeCompare(b.title));
		return tempWithReleaseDate.concat(tempWithoutReleaseDate);
	} else {
		return tempWithReleaseDate;
	}
};

//sorting the movies/events by date and when it's the same date sort by time
export const sortByDate = (events, ascending = true, byPublicationDate = false) => {
	const compareDates = (a, b) => {
		const dateA = byPublicationDate ? dbDateToTimestamp(a.publish_date) : a.date_range[0];
		const dateB = byPublicationDate ? dbDateToTimestamp(b.publish_date) : b.date_range[0];

		const timeA = byPublicationDate ? '' : a.times?.[0]?.program_start || '';
		const timeB = byPublicationDate ? '' : b.times?.[0]?.program_start || '';

		if (!dateA || !dateB) return 0;

		const timestampA = byPublicationDate ? new Date(dateA).getTime() : dbDateToTimestamp(dateA + '0000');
		const timestampB = byPublicationDate ? new Date(dateB).getTime() : dbDateToTimestamp(dateB + '0000');

		if (timestampA !== timestampB) {
			return ascending ? timestampA - timestampB : timestampB - timestampA;
		}

		if (!timeA || !timeB) return 0;

		const hourA = timeA.substring(8, 10);
		const hourB = timeB.substring(8, 10);
		const minuteA = timeA.substring(10, 12);
		const minuteB = timeB.substring(10, 12);

		if (hourA !== hourB) {
			return ascending ? hourA - hourB : hourB - hourA;
		}
		return ascending ? minuteA - minuteB : minuteB - minuteA;
	};

	const withDates = events.filter((event) => (byPublicationDate ? event.publish_date : event.date_range.length > 0));
	withDates.sort(compareDates);

	return withDates;
};

export const sortAlphabetically = (input) => {
	return input.sort((a, b) => a.title.localeCompare(b.title));
};

export const parseEntities = (txt) => {
	return new DOMParser().parseFromString(txt, 'text/html').body.innerText;
};

const bodyWidthEM = () => {
	return window.innerWidth / parseFloat(getComputedStyle(document.querySelector('body'))['font-size']);
};

// const checkForTouchScreen = () => {
// 	if ("ontouchstart" in document.documentElement) {
//   		return true;
// 	} else {
//   		return false;
// 	}
// }

export const hideAgenda = (hideOnHomeDesktop) => {
	if (!document.querySelector('.js_react_filter').classList.contains('js_react_filter_home')) {
		return true;
	} else {
		if (!hideOnHomeDesktop) {
			return true;
			// } else if (bodyWidthEM() < 37.5) {
		} else if (checkForTouchScreen()) {
			return true;
		} else {
			return false;
		}
	}
};

export const vwSet = () => {
	document.documentElement.style.setProperty('--vw', `${document.documentElement.clientWidth / 100}px`);
};

// export const scrollToBegin = (rootElement) => {
// 	const start = rootElement.querySelector(".tab-nav");
// 	if (start) {
// 		document.firstElementChild.style.scrollPaddingBlockStart = getComputedStyle(document.body).getPropertyValue('--header-height');
// 		start.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
// 	}
// }

export const scrollToBegin = () => {
	const start = document.querySelector('.agenda-start');
	const el = document.firstElementChild;
	if (start && el) {
		el.style.scrollPaddingBlockStart = getComputedStyle(document.body).getPropertyValue('--header-height');
		start.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
	}
};

export const scrollToFromTime = (rootElement, filteredMovies) => {
	const nearestShow = filteredMovies.find((movie) => {
		return movie.times[0].timestamp > +new Date().getTime(); //future development: use fromTime here
	});
	const nearestShowElement = rootElement.querySelector(`#movie-${nearestShow.post_id}-${nearestShow.times[0].timestamp}`);
	document.firstElementChild.style.scrollPaddingBlockStart = getComputedStyle(document.body).getPropertyValue('--header-height');
	nearestShowElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
};

export const getWeekNumber = (timestamp) => {
	const currentDate = new Date(timestamp);
	const onejan = new Date(currentDate.getFullYear(), 0, 1);
	return Math.ceil(((currentDate.getTime() - onejan.getTime()) / 86400000 + onejan.getDay()) / 7);
};

export const getNextMonday = (today) => {
	let newDate = new Date(today);
	newDate.setDate(newDate.getDate() + ((1 + 7 - newDate.getDay()) % 7 || 7));
	return newDate.getTime();
};

export const getTomorrow = (today) => {
	const now = new Date(today);
	return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1).getTime();
};
//change sat in fri for weekend FR/SAT/SUN
export const getThisWeekend = (today) => {
	const oneDayMilliseconds = 24 * 60 * 60 * 1000;
	const dayOfWeek = new Date(today).getDay();
	const daysUntilFri = (5 - dayOfWeek + 7) % 7; // 5 is vrijdag
	return today + daysUntilFri * oneDayMilliseconds;
};

export const getNextMonth = (today) => {
	const now = new Date(today);
	if (now.getMonth() == 11) {
		return new Date(now.getFullYear() + 1, 0, 1).getTime();
	} else {
		return new Date(now.getFullYear(), now.getMonth() + 1, 1).getTime();
	}
};

export const hasMatchingShowTags = (element, noSpecialTags) => {
	if (element.times && element.times.length > 0) {
		let matchingShowTags = false;
		element.times.forEach((show) => {
			show.tags &&
				show.tags.length > 0 &&
				show.tags.forEach((tag) => {
					if (!noSpecialTags || !noSpecialTags.includes(tag)) {
						matchingShowTags = true;
					}
				});
		});
		return matchingShowTags;
	}
	return false;
};

